import { APIError } from "../api";

export function formatAPIErrorForView(error: APIError): string {
  return error.getFirstError?.() || error.message || "Unknown error";
}
